import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { FilterUsers } from 'app/main/settings/users/UsersCacheContext';
import { IOption } from 'framework/IOption';
import { FilterBar } from 'framework/filter/FilterBar';
import { ListFilterComponent } from 'framework/filter/ListFilterComponent';
import { DateFilterItem } from 'framework/filter/date/DateFilterItem';
import { usePreloadCacheContext } from 'framework/hooks/usePreloadCacheContext';
import { clearParams } from 'framework/utils/clearParams';
import { isFiltered } from 'framework/utils/isFiltered';
import { ICommissionsQueryParams } from 'gen/ApiClient';
import { useLocalization } from 'localization/useLocalization';
import React, { useMemo } from 'react';
import { CommissionRulesCacheContext } from '../context/CommissionRulesCacheContext';

interface IProps {
	params: ICommissionsQueryParams;
	onFilter: (params: ICommissionsQueryParams) => void;
	paddingLeft: number;
}

const exclusions: (keyof ICommissionsQueryParams)[] = ['isPaidOut'];

export const Filter = ({ params, onFilter, paddingLeft }: IProps) => {
	const strings = useLocalization();
	const [rules] = usePreloadCacheContext(CommissionRulesCacheContext);
	const filterRules = useMemo(() => rules?.all.map<IOption<string>>(t => ({ id: t.id, identifier: `${t.name} (${t.percentage} %)` })), [rules]);

	if (filterRules === undefined) {
		return <div></div>;
	}

	return (
		<FilterBar
			isFiltered={isFiltered(params, exclusions)}
			onClear={() => onFilter(clearParams(params, exclusions))}
			paddingLeft={paddingLeft}>
			<DateFilterItem
				label={strings.dateCreated}
				after={params.createdAfter}
				before={params.createdBefore}
				setSelected={(after, before) => onFilter({ ...params, createdAfter: after, createdBefore: before })}
			/>
			<FilterUsers
				value={params.userIds}
				onChange={vals => onFilter({ ...params, userIds: vals })}
				options={{ includeBlocked: true, onlyAudiologists: false }}
			/>
			<ListFilterComponent<string>
				options={filterRules}
				selected={params.commissionRuleIds}
				setSelected={vals => onFilter({ ...params, commissionRuleIds: vals })}
				label={strings.rule}
				icon={<HelpOutlineIcon />}
				title={strings.rule}
			/>
		</FilterBar>
	);
};
